import { render, staticRenderFns } from "./AddDish.vue?vue&type=template&id=236e02f4&"
import script from "./AddDish.vue?vue&type=script&lang=js&"
export * from "./AddDish.vue?vue&type=script&lang=js&"
import style0 from "./AddDish.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports